import { PrimaryBlueButton, IconPlus } from "@velaro/velaro-component-lib";
import React, { useState } from "react";
import IvrIntegrationSetupModal from "./IvrIntegrationSetupModal";
import useApi from "@/hooks/useApi";

export default function AddPhoneNumberButton() {
  const [showSetupModal, setShowSetupModal] = useState(false);
  const api = useApi();

  const fetchIntegrations = async () => {
    // Trigger a custom event to refresh integrations
    window.dispatchEvent(new CustomEvent("refreshIvrIntegrations"));
  };

  return (
    <>
      <PrimaryBlueButton
        prefixIcon={<IconPlus />}
        onClick={() => setShowSetupModal(true)}
        label="Add Phone Number"
      />
      {showSetupModal && (
        <IvrIntegrationSetupModal
          onSuccess={() => {
            setShowSetupModal(false);
            fetchIntegrations();
          }}
          onClose={() => setShowSetupModal(false)}
        />
      )}
    </>
  );
}
